import { META, MetaProps, MetaValue } from './meta';
import { Platform } from './Platform';

export class PlatformMeta {
    public static getBasedOnPlatform(platform: string | Platform): MetaValue {
        const platform$ = Platform.from(platform);
        return META[platform$.getCompany()];
    }

    public static getPropOfPlatform<T = any>(prop: MetaProps, platform: string | Platform): T {
        return PlatformMeta.getBasedOnPlatform(platform)[prop];
    }
}

export const getMetaOfPlatform = (platform: string | Platform) => PlatformMeta.getBasedOnPlatform(platform);

export const getMetaPropOfPlatform = (prop: MetaProps, platform: string | Platform) =>
    PlatformMeta.getPropOfPlatform(prop, platform);
